import { render } from "./ydFromTemp.vue?vue&type=template&id=3149403c"
import script from "./ydFromTemp.vue?vue&type=script&lang=js"
export * from "./ydFromTemp.vue?vue&type=script&lang=js"

import "./ydFromTemp.vue?vue&type=style&index=0&id=3149403c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__